export const button = ({ theme: { colors } }) => ({
    display: 'block',
    color: colors.blue,
    borderBottom: `0.1875rem solid ${colors.blue}`,
    fontSize: '2rem',
    fontWeight: 'bold',
    float: 'right',
    marginTop: '6rem',
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',
    willChange: 'color',
    cursor: 'pointer',

    ':hover': {
        color: colors.fuchsia,
    },
});
